/* constants and global variables */
export default class enums {
    static affiateEntityColumn: any = {
        revenues: "Rev_3xxxxx_Revenue",
        expenditures: "Exp_5xxxx_7xxxx_Expenditures",
        debt: "AffiliateLongTermDebt",
    }

    static tableName: any = {
        nodata: "uas_001b_afr-no-data-declarations",
        affiliateNodata: "uas_001ba_afr-no-data-declarations",
        affiliatedEntity: "uas_062_affiliate-totals",
        expenditures: "uas_034_expenditures",
        balanceSheet: "uas_006_balance-sheet",
        revenues: "uas_020_revenue",
        impactfees: "uas_020_revenue_dwellings_and_fees",
        longTermDebt: "uas_005a_long-term-debt",
        otherAfrData: "uas_001_unit-information",
        dew: "uas_063_data-element-worksheet",
        compensation: "uas_065_compensation",
        affiliatecompensation: "uas_065a_compensation",
        projects: "uas_064_projects",
        affiliateprojects: "uas_064a_projects",
        bonds: "uas_068_bonds",
        millagerates: "uas_066_millage-rates",
        specialassessmentrates: "uas_067_special-assessment-rates"
    }

    static dataSectionAlias: any = {
        "uas_001b_afr-no-data-declarations": "No Data",
        "uas_001ba_afr-no-data-declarations": "Affiliate No Data",
        "uas_062_affiliate-totals": "Affiliate Totals",
        "uas_034_expenditures": "Expenditures",
        "uas_006_balance-sheet": "Balance Sheet Items",
        "uas_020_revenue": "Revenues",
        "uas_020_revenue_dwellings_and_fees": "Revenues",
        "uas_005a_long-term-debt": "Long Term Debt",
        "uas_001_unit-information": "Unit Information",
        "uas_063_data-element-worksheet": "DEW",
        "uas_065_compensation": "Compensation",
        "uas_065a_compensation": "Affiliate Compensation",
        "uas_064_projects": "Construction Projects",
        "uas_064a_projects": "Affiliate Construction Projects",
        "uas_068_bonds": "Bonds",
        "uas_066_millage-rates": "Millage Rates",
        "uas_067_special-assessment-rates": "Special Assessment Rates"
    }

    static nodataAreaName : any = {
        projects: "AFRND_ConstructionProjectsMember",
        bonds: "AFRND_BondsMember",
        revenues: "AFRND_RevenuesMember",
        expenditures: "AFRND_ExpendituresMember",
        balances: "AFRND_BalanceSheetMember",
        workState_noConstructionProjects: "AFRND_ConstructionProjectsMember",
        workState_noBonds: "AFRND_BondsMember",
        workState_noRevenues: "AFRND_RevenuesMember",
        workState_noExpenditures: "AFRND_ExpendituresMember",
        workState_noBalanceSheet: "AFRND_BalanceSheetMember",
        CourtInnovations: "CR_939_ND_CourtInnovations",
        LegalAidProgram: "CR_939_ND_LegalAidProgram",
        LawLibrary: "CR_939_ND_LawLibrary",
        JuvenileAlternativeProgram: "CR_939_ND_JuvenileAlternativeProgram"
    }

    static doneWorkStateName: any = {
        balanceSheet: "workState_balanceSheetComplete",
        revenues: "workState_revenuesComplete",
        expenditures: "workState_expendituresComplete",
        governmental: "workState_governmentalFundsComplete",
        proprietary: "workState_proprietaryFundsComplete",
        fiduciary: "workState_fiduciaryFundsComplete",
        units: "workState_componentUnitsFundsComplete"
    }

    static noDataWorkStateName: any = {
        balanceSheet: "workState_noBalanceSheet",
        revenues: "workState_noRrevenues",
        expenditures: "workState_noExpenditures",
        governmental: "workState_noGovernmentalFunds",
        proprietary: "workState_noProprietaryFunds",
        fiduciary: "workState_noFiduciaryFunds",
        units: "workState_noComponentUnitsFunds"
    }

    static rowCode: any = {
        population: "population",
        longTermDebtAmount: "900001",
    }


    static AFRStatus: any = {
        created: "CREATED",
        in_progress: "IN_PROGRESS",
        certified: "CERTIFIED_BY_ENTITY",
        recertified: "RE_CERTIFIED_BY_ENTITY",
        verified: "VERIFIED",
        returned_by_dfs: "RETURNED_BY_DFS",
        not_reported: "NOT_REPORTED",
        imported: "IMPORTED",
        submitted: "SUBMITTED",
        reported_by_primary: "REPORTED_BY_PRIMARY",
        unknown: "UNKNOWN",
        amendment_in_progress_by_dfs: "AMENDMENT_IN_PROGRESS_BY_DFS"
    }


    static AFRStatusDescription: any = {
        created: "Created",
        in_progress: "In Progress",
        certified_by_entity: "Certified By Entity",
        re_certified_by_entity: "Re-certified By Entity",
        verified: "Verified by DFS",
        returned_by_dfs: "Returned By DFS",
        not_reported: "Not Reported",
        imported: "Imported",
        submitted: "Submitted",
        reported_by_primary: "Reported by Primary",
        unknown: "Unknown",
        amendment_in_progress_by_dfs: "Amendment In Progress by DFS"
    }

    // The audit object is linked from Affiliated Entity or Current version
    static auditSource: any = {
        affiliatedEntity: "AffiliatedEntity",
        AFRCurrentVersion: "CurrentVersion",
    }

    static pdfType: any = {
        AffiliatedEntityAudit: "AuditAffiliatedEntity",
        AFRAudit: "AuditAFR",
        AFRExceptions: "AFRExceptions",
        AFRWaivers: "AFRWaivers",
        AFRAffidavit: "AFRAffidavit",
        AEBudgetVarianceReport: "AFRBudgetVarianceReport",
    }

    static eventName = {
        returned_by_dfs: "returned by dfs",
    }

    static assigmentStatus = {
        ready: "READY",
        returned: "RETURNED",
        verified: "VERIFIED",
    }

    static bypassStatus: any = {
        pending: "PENDING",
        withdrawn: "WITHDRAWN",
        approved: "APPROVED",
        rejected: "REJECTED"
    }

    static bypassStatusDisplay: any = {
        PENDING: "Pending",
        WITHDRAWN: "Withdrawn",
        APPROVED: "Accepted",
        REJECTED: "Rejected"
    }

    static bypassEventRoles: any = {
        request: "REQUEST_ACCOUNT_BYPASS",
        withdraw: "BYPASS_WITHDRAWAL",
        approve: "BYPASS_APPROVAL",
        reject: "BYPASS_REJECTION"
    }

    static auditorEventRoles: any = {
        request: "REQUEST_AUDITOR",
        withdraw: "AUDITOR_WITHDRAWAL",
        approve: "AUDITOR_APPROVAL",
        reject: "AUDITOR_REJECTION"
    }

    static dateOverrideEventRoles: any = {
        dateOverride: "DATE_OVERRIDE"
    }

    static UISection: any = {
        summary: "01",
        importAfrData: "02",
        balanceSheet: "03",
        revenues: "04",
        revenuesRevenuesTab: "04_1",
        revenuesImpactFeesTab: "04_2",
        expenditures: "05",
        longTermDebt: "06",
        otherAfrData: "07",
        otherAfrDataProjects: "07_1",
        otherAfrDataBonds: "07_2",
        affiliatedEntities: "08",
        audit: "09",
        certification: "10",
        reports: "11",
        errors: "12",
        instructions: "13",
        importErrors: "99"
    }
    static UISection_FundGroup: any = {
        summary: "01",
        importAfrData: "02",
        longTermDebt: "06",
        otherAfrData: "07",
        otherAfrDataProjects: "07_1",
        otherAfrDataBonds: "07_2",
        affiliatedEntities: "08",
        audit: "09",
        certification: "10",
        reports: "11",
        errors: "12",
        instructions: "13",
        governmentalFunds: "14",
        proprietaryFunds: "15",
        fiduciaryFunds: "16",
        componentUnitsFunds: "17",
        importErrors: "99"
    }
    static UISection_FundGroup_NoAffiliates: any = {
        summary: "01",
        importAfrData: "02",
        longTermDebt: "06",
        otherAfrData: "07",
        otherAfrDataProjects: "07_1",
        otherAfrDataBonds: "07_2",
        affiliatedEntities: "08",
        audit: "09",
        certification: "10",
        reports: "11",
        errors: "12",
        instructions: "13",
        governmentalFunds: "14",
        proprietaryFunds: "15",
        fiduciaryFunds: "16",
        importErrors: "99"
    }
    static UISectionName: any = {
        "14": "governmental",
        "15": "proprietary",
        "16": "fiduciary",
        "17": "units"
    }

    static UISectionDisplayName: any = {
        "14": "Governmental Funds",
        "15": "Proprietary Funds",
        "16": "Fiduciary Funds",
        "17": "Discrete Component Units Funds"
    }

    static UISection_CR29: any = {
        summary: "01",
        certification: "10",
        reports: "11",
        errors: "12",
        instructions: "13",
        CR29PartA: "30",
        CR29PartB: "31",
        CR29PartC: "32",
        CR29PartD: "33",
        CR29PartE: "34",
        importErrors: "99"
    }

    static UISection_CR939: any = {
        summary: "01",
        reports: "11",
        errors: "12",
        instructions: "13",
        courtInnovations: "21",
        legalAidProgram: "22",
        lawLibrary: "23",
        juvenileAlternativeProgram: "24",
        dataSummary: "25",
        importErrors: "99"
    }

    // sections where the check mark is required
    static checkMarkRequiredSections: any = {
        balanceSheet: "03",
        revenues: "04",
        expenditures: "05",
        longTermDebt: "06",
        otherAfrData: "07",
        affiliatedEntities: "08",
        audit: "09",
        certification: "10",
    }

    static checkMarkRequiredSections_FundGroup: any = {
        longTermDebt: "06",
        otherAfrData: "07",
        affiliatedEntities: "08",
        audit: "09",
        certification: "10",
        governmentalFunds: "14",
        proprietaryFunds: "15",
        fiduciaryFunds: "16",
        componentUnitsFunds: "17"
    }

    static checkMarkRequiredSections_CR29: any = {
        summary: "01",
        certification: "10",
        CR29PartA: "30",
        CR29PartB: "31",
        CR29PartC: "32",
        CR29PartD: "33",
        CR29PartE: "34"
    }

    static checkMarkRequiredSections_CR939: any = {
        courtInnovations: "21",
        legalAidProgram: "22",
        lawLibrary: "23",
        juvenileAlternativeProgram: "24"
    }


    static sectionExcludedByYear: any = {
        "2012": [enums.UISection.balanceSheet, enums.UISection.otherAfrData],
        "2013": [enums.UISection.balanceSheet, enums.UISection.otherAfrData],
        "2014": [enums.UISection.balanceSheet, enums.UISection.otherAfrData],
        "2015": [enums.UISection.balanceSheet, enums.UISection.otherAfrData],
        "2016": [enums.UISection.balanceSheet, enums.UISection.otherAfrData],
        "2017": [enums.UISection.balanceSheet, enums.UISection.otherAfrData],
        "2018": [enums.UISection.balanceSheet, enums.UISection.otherAfrData],
        "2019": [enums.UISection.balanceSheet, enums.UISection.otherAfrData],
        "2020": [enums.UISection.balanceSheet, enums.UISection.otherAfrData],
        "2021": [enums.UISection.balanceSheet]
    };



    static tableExludedByYear = [
        { year: "2012", tables: [{ code: enums.tableName.impactfees },] },
        { year: "2013", tables: [{ code: enums.tableName.impactfees },] },
        { year: "2014", tables: [{ code: enums.tableName.impactfees },] },
        { year: "2015", tables: [{ code: enums.tableName.impactfees },] },
        { year: "2016", tables: [{ code: enums.tableName.impactfees },] },
        { year: "2017", tables: [{ code: enums.tableName.impactfees },] },
        { year: "2018", tables: [{ code: enums.tableName.impactfees },] },
        { year: "2019", tables: [{ code: enums.tableName.impactfees },] },
    ];


    static verifiedCertifiedRecertified = enums.AFRStatus.certified + "," +
        enums.AFRStatus.recertified + "," +
        enums.AFRStatus.verified + ",";

    static certifiedRecertified = enums.AFRStatus.certified + "," +
        enums.AFRStatus.recertified;

    static entityType: any = {
        county: "COUNTY",
        city: "CITY",
        specialDistrict: "SPECIAL_DISTRICT",
        other: "OTHER_ENTITY"
    }

    static documentRole: any = {
        audit: "AUDIT",
        impact_fee_exception: "IMPACT_FEE_EXCEPTION",
        impact_fee_waiver: "IMPACT_FEE_WAIVER",
        affidavit: "IMPACT_FEE_AFFIDAVIT",
        budget_variance_report: "BUDGET_VARIANCE_REPORT",
        AUDIT: "AUDIT",
        IMPACT_FEE_EXCEPTION: "IMPACT_FEE_EXCEPTION",
        IMPACT_FEE_WAIVER: "IMPACT_FEE_WAIVER",
        IMPACT_FEE_AFFIDAVIT: "IMPACT_FEE_AFFIDAVIT",
        BUDGET_VARIANCE_REPORT: "BUDGET_VARIANCE_REPORT",
    }

    static documentRoleLabel: any = {
        AUDIT: "Audit PDF",
        IMPACT_FEE_EXCEPTION: "Impact Fee Exception",
        IMPACT_FEE_WAIVER: "Impact Fee Waiver",
        IMPACT_FEE_AFFIDAVIT: "Impact Fee Affidavit",
        BUDGET_VARIANCE_REPORT: "Budget Variance Report",
    }

    static CR29DocumentRoleLabel: any = {
        CR_29_CPA_LETTER: "CPA Letter",
        CR_29_SIGNED_TEMPLATE: "Signed Template"
    }

    static CR29DocumentRoleLabel_2024: any = {
        CR_29_CPA_LETTER: "CPA Letter"
    }


    static commentType = {
        admin: "AFR_ADMIN_COMMENT",
        review: "AFR_ADMIN_REVIEW_COMMENT",
    }

    static affiliatedEntityReportingType: any = {
        independent: "INDEPEND",
        discrete: "DISCRETE",
        blended: "BLENDED",
        zero: "ZEROREPT",
        nonComponentUnit: "NONCOMPO",
        notSpecified: "NOT_SPECIFIED",
    }

    static rptTypeOptions : any = {
        "NONCOMPO": "Not a Component Unit",
        "BLENDED": "Blended in Primary Report",
        "INDEPEND": "Independently Reported",
        "DISCRETE": "Discretely Reported",
        "ZEROREPT": "Zero Revenues and Expenditures"
    };

    static affiliatedEntityTotalZeroField: any = {
        totalRevenues: "Rev_3xxxxx_Revenue",
        totalExpenditures: "Exp_5xxxx_7xxxx_Expenditures",
        Rev_3xxxxx_Revenue: "Total Revenues",
        Exp_5xxxx_7xxxx_Expenditures: "Total Expenditures"
    }

    static errorType = {
        sectionRuleEvaluator: "AFR Navigator",
        unassignedFact: "Unassigned fact"
    }

    static validationErrorCategory = {
        missingFact: "REQUIRED_CONCEPT_NOT_FOUND"
    }

    static severity: any = {
        error: 1,
        warning: 2,
        information: 3
    }
    static conceptDatatype: any = {
        NONE: "none",
        STRING: "string",
        ANYURI: "uri",
        NONNUM_DOMAINITEMTYPE: "domain",
        XBRLI_STRINGITEMTYPE: "string",
        XBRLI_MONETARYITEMTYPE: "money",
        XBRLI_NONNEGATIVEINTEGERITEMTYPE: "whole number",
        DATE: "date",
        XBRLI_DATEITEMTYPE: "date",
        XBRLI_GYEARITEMTYPE: "year",
        XBRLI_BOOLEANITEMTYPE: "bool",
        ENUM2_ENUMERATIONITEMTYPE: "enumerated fact",
        ENUM_2_ENUMERATIONITEMTYPE: "enumerated fact",
        UAS_CODES_YESNOITEMTYPE: "bool",
        UAS_CODES_SUPPORTINGDOCUMENTATIONITEMTYPE: "supporting document",
        UAS_CODES_TYPEOFGOVERNMENTITEMTYPE: "type of government",
        UAS_CODES_YESNONOTAPPLICABLEITEMTYPE: "yesNoNa",
        UAS_CODES_COUNTYAREAINCORPORATEDORUNINCORPORATEDITEMTYPE: "incorporation type",
        UAS_CODES_DISTRICTTYPEITEMTYPE: "district type",
        DTR_TYPES_PERCENTITEMTYPE: "percent",
        DTR_TYPES_PERCENT_ITEM_TYPE: "percent",
        DTR_TYPES_DOMAINITEMTYPE: "domain"

    }

    static conceptCreationDatatype: any = {
        ANYURI: "uri",
        XBRLI_STRINGITEMTYPE: "string",
        XBRLI_MONETARYITEMTYPE: "money",
        XBRLI_NONNEGATIVEINTEGERITEMTYPE: "whole number",
        XBRLI_DATEITEMTYPE: "date",
        XBRLI_GYEARITEMTYPE: "year",
        XBRLI_BOOLEANITEMTYPE: "bool",
        DTR_TYPES_PERCENTITEMTYPE: "percent",
    }

    static dependencyRelationshipMapping: any = {
        TEST: "test",
        EXISTS: "exists",
        NOT_EXISTS: "not exists",
        EXISTS_ALL: "all exist",
        EXISTS_ANY: "any exist",
        EXISTS_NONE: "none exist",
        EXISTS_ONE: "one exists",
        GREATER_THAN: ">",
        LESS_THAN: "<",
        GREATER_THAN_EQUAL: ">=",
        LESS_THAN_EQUAL: "<=",
        EQUALS: "=",
        NOT_EQUALS: "!="
    }

    static dependencyRelationship: any = {
        TEST: "TEST",
        EXISTS: "EXISTS",
        NOT_EXISTS: "NOT_EXISTS",
        EXISTS_ALL: "EXISTS_ALL",
        EXISTS_ANY: "EXISTS_ANY",
        EXISTS_NONE: "EXISTS_NONE",
        EXISTS_ONE: "EXISTS_ONE",
        GREATER_THAN: "GREATER_THAN",
        LESS_THAN: "LESS_THAN",
        GREATER_THAN_EQUAL: "GREATER_THAN_EQUAL",
        LESS_THAN_EQUAL: "LESS_THAN_EQUAL",
        EQUALS: "EQUALS",
        NOT_EQUALS: "NOT_EQUALS",
        NONE: "NONE"
    }

    static referenceTypes : any = {
        standard: "http://www.xbrl.org/2003/role/reference",
        private: "https://www.apps.fldfs.com/LocalGov/uas/roles/reference/local",
        dew: "https://www.apps.fldfs.com/LocalGov/uas/roles/reference/dew",
        courtrelated: "urn:uas:referencerole:court-related",
        privaterootid: "https://www.apps.fldfs.com/LocalGov/uas/roles/reference/local/",
        sharedrootid: "http://www.xbrl.org/2003/role/reference/shared/",
        info: "https://www.apps.fldfs.com/LocalGov/info/roles/reference/instruction"
    }

    static changeTrackingPrefix: any = {
        REFCHANGE: "RefChange_",
        REFASSIGNCHANGE: "RefAssignChange_",
        LABELCHANGE: "LabelChange_",
        CONCEPTCHANGE: "ConceptChange_",
        PARTDEFINITIONCHANGE: "PartDefinitionChange_",
        CUSTOMEROLECHANGE: "CustomRoleChange_",
        DEPRECATIONCHANGE: "DeprecationChange_",
        RELATIONSHIPCHANGE: "RelationshipChange_",
        ENTITYSCOPECHANGE: "EntityScopeChange_",
        DIMENSIONALSCOPECHANGE: "DimensionalScopeChange_",
        DEPENDENCYCHANGE: "DependencyChange_"
    }
    static axisIds: any = {
        ReportingUnit: "ReportingUnitAxis",
        ObjectCode: "ObjectCodesAxis"
    }

    static CR29PartDescriptors: any = {
        PARTA_TITLE: "Part A - Revenues",
        PARTA_TABLE_TITLE: "Local Requirement Collections",
        PARTA_TABLE_NAME: "cr29-court-reporting-local-requirements-collections",
        PARTB_TITLE: "Part B - Non-Recurring Fixed Capital Outlay Expenditures",
        PARTB_TABLE_TITLE: "Fixed Capital Outlay Cost",
        PARTB_TABLE_NAME: "cr29-court-reporting-non-recurring-expenditures",
        PARTC_TITLE: "Part C - Operating Expenditures",
        PARTC_TABLE_TITLE_1: "Facility Cost",
        PARTC_TABLE_NAME_1: "cr29-court-reporting-facility-cost",
        PARTC_TABLE_TITLE_2: "Communications Systems and Services",
        PARTC_TABLE_NAME_2: "cr29-court-reporting-communications-systems-and-services",
        PARTC_TABLE_TITLE_3: "Existing Systems",
        PARTC_TABLE_NAME_3: "cr29-court-reporting-existing-systems",
        PARTD_TITLE: "Part D - Local Requirements",
        PARTD_TABLE_TITLE: "Local Requirement",
        PARTD_TABLE_NAME: "cr29-court-reporting-local-requirements",
        PARTE_TITLE: "Part E - Other Operating Court Related Expenditures",
        PARTE_TABLE_TITLE: "Other Operating Expenses",
        PARTE_TABLE_NAME: "cr29-court-reporting-other-operating-court-related-expenditures",
    }

    static rateMemberPublicNames: any = {
        MinimumMember: "Minimum Rate",
        MaximumMember: "Maximum Rate",
        MedianMember: "Single Rate",
        RateCategoryAxis: "Rate Category"
    }

}